/**
* 用户管理 用户列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>承诺书设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="margin-right:2%;">
        <h1 style="color: red;">公告标题和内容有一个为空则不会生效！</h1>
        <!-- <el-button style='margin: 10px 0;margin-right: 20px;' size="mini" type="primary"
            icon="document" @click="dataSelect">刷新</el-button> -->
        <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document" @click="addNotice">新增</el-button>  -->
            
            <!-- <img v-if="img" :src="img" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> tableData-->
    </div>

    <div style="margin-bottom: 10px;">
        <h1 style="width: 100%;display: inline-block;text-align: center;">承诺书设置</h1>
    </div>

    <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">标题：</span>
        <el-input style="width:71%;" v-model="tableData.title" placeholder="输入标题"></el-input>
      </div>

      <div style="margin-bottom: 10px;display: flex;align-items: center;">
        <span style="width: 200px;display: inline-block;text-align: right;">内容：</span>
        <quill-editor ref="myTextEditor" v-model="tableData.content" :options="quillOption"
					style="padding-bottom: 50px;height: 300px;width: 72%;display: inline-table;margin-bottom: 60px;">
				</quill-editor>
        <!-- <el-input style="width:50%;" type="textarea" v-model="updateForm.content" placeholder="输入内容"></el-input> -->
      </div>

      <div  style="margin-bottom: 10px;width: 100%;text-align: center;">
        <el-button style="display: inline-block;text-align: center;" type="primary" @click="updateFrom(tableData)">保 存</el-button>
        <!-- <h1 >承诺书设置</h1> -->
    </div>


    <!-- <el-dialog title="添加价格配置" :visible.sync="dialogFormVisible" center>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">价格：</span>
        <el-input style="width:50%;" v-model="price" placeholder="请输入价格"></el-input>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">每个月免费次数：</span>
        <el-input style="width:50%;" v-model="frequency" placeholder="请输入每个月免费次数"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="releasNoticeTo()">确 定</el-button>
      </div>
    </el-dialog> -->


  </div>
</template>

<script>
import { addCarousel , deleteCarousel , getCarouselList } from '../../../api/manage/carousel.js'
import { addCommitment , deleteCommitment , getCommitmentInfo , updateCommitment } from '../../../api/manage/commitment.js'
import moment from 'moment';

export default {
  data() {
    return {
        multipleSelection: [],
        totalnum:0,
        page : 1 ,
        size : 10,
        tableDataLoading:false,
        dialogFormVisible:false,
        tableData:[],
        addForm:{
            url:''
        },
        updateForm:{
            
        },

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    deletes(id){
      let obj = {
          id:id,
      }
      this.$confirm(`确定删除此条信息?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCarousel(obj).then(res => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => {})
    },

    updateFrom(data){
      let post = data
      updateCommitment(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
            this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
      })
    },

    dataSelect(){
      let post = {
        page : (this.page - 1 ) * this.size,
        size : this.size
      }
      this.tableDataLoading = true
      getCommitmentInfo(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
            this.tableData = res.data.data
            // console.log('this.tableDatathis.tableData',this.tableData)
            // console.log("tableData",this.tableData)
            return;
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
    })

    },

     // 添加分类弹框
    addNotice() {
        this.addForm = ''
        this.dialogFormVisible = true
    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/commitment/index.vue